import useDeviceEnv from "@/views/Home/useData/useDeviceEnv/useDeviceEnv";
// useDeviceEnv
const { deviceInfo, mixins: deviceInfoMixins } = useDeviceEnv();

export { deviceInfo, deviceInfoMixins };
